export default __webpack_public_path__ + "static/media/SafeAsk_Trademarked_Logo.e52395f8.png";